import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  IconButton,
  Typography,
  Grid,
  Paper,
  Button
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import LambdaFetch from '../functions/FetchFromLambda'
import LoadingButton from '../components/LoadingButton'
import { payrollDistributionCols } from '../constants/PayrollCols'
import LoadingCircle from '../components/common/LoadingCircle'
import { smallScreenWidth } from '../constants/AppConstants'
import AutocompleteDropDown from '../components/AutocompleteDropdown'
import ServerSideAutoCompletev2 from '../functions/ServerSideAutoCompletev2'
import { DashboardAthenaTableServerSideNoSelect } from '../components/DashboardAthenaTableServerSideNoSelect'
import DateInput from '../components/DateInput'


const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    margin: '2rem 1rem'
  },
  treeRoot: {
    flexGrow: 1,
    margin: '1rem'
  }
}))

const defaultHeaders = {
  company: null,
  employee: '',
  fromDate: '',
  toDate: ''
}

export default function PayrollDistribution (props) {
  const [state, setstate] = useState({
    isLoading: false,
    data: null,
    tableKey: JSON.stringify(defaultHeaders)
  })
  const [showTable, setShowTable] = useState(false)
  const [headers, setHeaders] = useState(defaultHeaders)
  const [clearHeader, setClearHeaders] = React.useState(false)

  const classes = useStyles()

  const { credentials } = props.fetchInitialData

  const handleChange = (name, value) => {
    setHeaders({ ...headers, [name]: !!value ? value.id : null })
  }

  const handleSubmit = e => {
    e.preventDefault()
    if (JSON.stringify(headers) === state.tableKey) return null
    setShowTable(true)
    setstate({ ...state, isLoading: true, tableKey: JSON.stringify(headers) })
  }

  const handleCallback = (values, error) => {
    if (error) {
      setstate({ ...state, isLoading: false })
      setShowTable(false)
      return null
    }
    setstate({ ...state, isLoading: false })
  }



  return (
    <div style={{ padding: '1.5rem 0.5rem' }}>
      <IconButton
        style={{ borderRadius: '5px', position: 'absolute' }}
        size='small'
        onClick={() => props.history.push('/')}
        aria-label='delete'
      >
        <ArrowBackIcon />
        {props.fetchInitialData.credentials.appWidth > smallScreenWidth &&
          'Dashboard'}
      </IconButton>
      <Typography variant='h5' style={{ textAlign: 'center' }}>
        Payroll Distribution
      </Typography>
      <div className={classes.root}>
        <Paper elevation={0} style={{ padding: '1rem' }}>
          <form onSubmit={handleSubmit}>
            <Grid
              container
              alignContent='center'
              alignItems='flex-start'
              spacing={3}
            >
              {[
                {
                  id: 'company',
                  label: 'Company',
                  screen: 'employee',
                  category: 'company',
                  isRequired: true
                }
              ].map(cur => {
                return (
                  <Grid item key={cur.id}>
                    <AutocompleteDropDown
                      {...props}
                      id={cur.id}
                      name={cur.id}
                      width='250px'
                      key={`${cur.id}-${clearHeader}`}
                      required={cur.isRequired}
                      variant='standard'
                      label={cur.label}
                      value={headers[cur.id]}
                      category={cur.category}
                      screen={cur.screen}
                      onChange={val =>
                        setHeaders({
                          ...headers,
                          [cur.id]: val ? val.key_value : null
                        })
                      }
                    />
                  </Grid>
                )
              })}
              <Grid item>
                <ServerSideAutoCompletev2
                  disabled={!headers.company}
                  required={true}
                  key={`employee-${clearHeader}`}
                  id='employee'
                  width='250px'
                  label='Employee'
                  accessToken={credentials.user.accessToken}
                  error='No Employee found'
                  variant='standard'
                  handleChange={(id, hit) => {
                    setHeaders({ ...headers, employee: id ? id : null })
                  }}
                  credentials={credentials}
                  apiResource='autocomplete-sql'
                  secondaryParams={{
                    limit: 100,
                    company: headers.company
                  }}
                  dontOpenOnFocus
                />
              </Grid>
              {[
                {
                  id: 'fromDate',
                  label: 'From Date',
                  isRequired: true
                },
                {
                  id: 'toDate',
                  label: 'To Date',
                  isRequired: true,
                }
              ].map(field => {
                return (
                  <Grid key={field.id} item>
                    <DateInput
                      id={field.id}
                      key={clearHeader}
                      label={field.label}
                      value={headers[field.id] || ''}
                      onChange={e => {
                        setHeaders({
                          ...headers,
                          [field.id]: !!e.target.value ? e.target.value : null
                        })
                      }}
                      required={field.isRequired}
                      variant='standard'
                      width='250px'
                      style={{ marginTop: '5px' }}
                      helperText={field.helperText}
                    />
                  </Grid>
                )
              })}
            </Grid>

            <div style={{ marginTop: '1rem' }}>
              <LoadingButton
                label='Submit'
                disabled={!(headers.fromDate && headers.toDate)}
                isLoading={state.isLoading}
                color='primaryVLButton'
                buttonType='submit'
              />
              {!!Object.values(headers).some(value => value !== '') && (
                <Button
                  onClick={() => {
                    setClearHeaders(!clearHeader)
                    setHeaders(defaultHeaders)
                  }}
                  style={{ marginLeft: '0.5rem' }}
                >
                  {' '}
                  Clear
                </Button>
              )}
            </div>
          </form>
        </Paper>

        {showTable && (
          <div style={{ marginTop: '1rem ' }}>
            <DashboardAthenaTableServerSideNoSelect
              {...props}
              key={state.tableKey}
              params={{ ...headers }}
              tableColumns={payrollDistributionCols}
              reportParamName="pr_payroll_distribution_temp"
              reportName='pr_payroll_distribution_temp'
              tableTitle={''}
              callback={handleCallback}
              transform={r => r}
              downloadFileName={'Payroll_Distribution_Download'}
              separatedDateFilters={{
                GL_DATE: ['fromDate', 'toDate'],
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}
